/* eslint-disable class-methods-use-this, no-restricted-syntax, no-underscore-dangle */

class NoopCmsConfiguration {
  // eslint-disable-next-line no-useless-constructor, no-unused-vars, no-empty-function
  constructor(config) {}

  getConfig() {
    return {};
  }
}

export default NoopCmsConfiguration;
